import { render, staticRenderFns } from "./UserRegister.vue?vue&type=template&id=5d572ca0&scoped=true&"
import script from "./UserRegister.ts?vue&type=script&lang=ts&"
export * from "./UserRegister.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d572ca0",
  null
  
)

export default component.exports